import React from "react";
import { Link, useNavigate } from "react-router-dom";
import section2img from "../assests/HomeImg/section2-img.svg";
import "./index.css";

// ── PDF Imports ──────────────────────────────────────────────────────────────
import pdf_coc from "../assests/DiclosureUnderRegulationPdf/Code-of-Conduct&Ethics_Board-of-Directors.pdf";
import pdf_criteria from "../assests/DiclosureUnderRegulationPdf/Criteria-of-making-payments-to-non-executive-directors.pdf";
import pdf_familiar from "../assests/DiclosureUnderRegulationPdf/Details-of-familiarization-programmes-imparted-to-independent-directors.pdf";
import pdf_dividend from "../assests/DiclosureUnderRegulationPdf/Dividend-Distribution-policy-as-per-Regulation-43A(1).pdf";
import pdf_esop from "../assests/DiclosureUnderRegulationPdf/Employee-Benefit-scheme-documents.pdf";
import pdf_materiality from "../assests/DiclosureUnderRegulationPdf/Materiality-Policy-as-per-Regulation-30(4).pdf";
import pdf_material_sub from "../assests/DiclosureUnderRegulationPdf/Policy-for-determining-material-subsidiaries.pdf";
import pdf_rpt from "../assests/DiclosureUnderRegulationPdf/Policy-on-dealing-with-related-party-transactions.pdf";
import pdf_terms from "../assests/DiclosureUnderRegulationPdf/Terms-Conditions-of-Independent-Directors.pdf";
import pdf_Details_of_establishment from "../assests/DiclosureUnderRegulationPdf/Details-of-establishment-of-vigil-mechanism-Whistle-Blower-policy.pdf";

// ── Arrow Icon ───────────────────────────────────────────────────────────────
const ArrowIcon = () => (
    <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.91797 7H11.0846" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 2.91666L11.0833 6.99999L7 11.0833" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// ── Disclosure Data ──────────────────────────────────────────────────────────
// url: pdf file  |  internalRoute: navigate within app  |  notApplicable: show N/A badge
const DISCLOSURE_DATA = [
    {
        num: "1.1",
        description: "Details of business",
        internalRoute: "/",
    },
    {
        num: "1.2",
        description: "Memorandum of Association and Articles of Association",
        internalRoute: "/shareholder-information",
    },
    {
        num: "1.3",
        description: "Brief profile of board of directors including directorship and full-time positions in body corporates",
        internalRoute: "/about#leadership-section",
    },
    {
        num: "2",
        description: "Terms and conditions of appointment of independent directors",
        url: pdf_terms,
    },
    {
        num: "3",
        description: "Composition of various committees of board of directors",
        internalRoute: "/about#leadership-section",
    },
    {
        num: "4",
        description: "Code of conduct of board of directors and senior management personnel",
        url: pdf_coc,
    },
    {
        num: "5",
        description: "Details of establishment of vigil mechanism/ Whistle Blower policy",
        url: pdf_Details_of_establishment,
    },
    {
        num: "6",
        description: "Criteria of making payments to non-executive directors",
        url: pdf_criteria,
    },
    {
        num: "7",
        description: "Policy on dealing with related party transactions",
        url: pdf_rpt,
    },
    {
        num: "8",
        description: "Policy for determining 'material' subsidiaries",
        url: pdf_material_sub,
    },
    {
        num: "9",
        description: "Details of familiarization programmes imparted to independent directors",
        url: pdf_familiar,
    },
    {
        num: "10",
        description: "Email address for grievance redressal and other relevant details",
        internalRoute: "/investor-contacts",
    },
    {
        num: "11",
        description: "Contact information of the designated officials of the listed entity who are responsible for assisting and handling investor grievances",
        internalRoute: "/investor-contacts",
    },
    {
        num: "12",
        description: "Financial results",
        internalRoute: "/financial",
    },
    {
        num: "13",
        description: "Shareholding pattern",
        internalRoute: "/shareholder-information?tab=Shareholding+Pattern",
    },
    {
        num: "14",
        description: "Details of agreements entered into with the media companies and/or their associates",
        notApplicable: true,
    },
    {
        num: "15.1",
        description: "(I) Schedule of analyst or institutional investor meet (II) Presentations prepared by the listed entity for analysts or institutional investors meet, post earnings or quarterly calls prior to beginning of such events.",
        internalRoute: "/shareholder-information",
    },
    {
        num: "15.2",
        description: "Audio recordings, video recordings, if any, and transcripts of post earnings or quarterly calls, by whatever name called, conducted physically or through digital means",
        internalRoute: "/financial",
    },
    {
        num: "16",
        description: "The Name of the Company has been changes from Sequent Scientific Limited to Viyash Scientific Limited.",
        notApplicable: true,
    },
    {
        num: "17",
        description: "Advertisements as per regulation 47(1)",
        internalRoute: "/shareholder-information",
    },
    {
        num: "18",
        description: "Credit rating or revision in credit rating obtained",
        internalRoute: "/shareholder-information",
    },
    {
        num: "19",
        description: "Separate audited financial statements of each subsidiary of the listed entity in respect of a relevant financial year",
        internalRoute: "/CorporateGovernance",
    },
    {
        num: "20",
        description: "Secretarial Compliance Report",
        internalRoute: "/shareholder-information",
    },
    {
        num: "21",
        description: "Materiality Policy as per Regulation 30(4)",
        url: pdf_materiality,
    },
    {
        num: "22",
        description: "Disclosure of contact details of KMP who are authorized for the purpose of determining materiality as required under regulation 30(5)",
        internalRoute: "/investor-contacts",
    },
    {
        num: "23",
        description: "Disclosures under regulation 30(8)",
        internalRoute: "/shareholder-information",
    },
    {
        num: "24",
        description: "Statements of deviation(s) or variations(s) as specified in regulation 32",
        notApplicable: true,
    },
    {
        num: "25",
        description: "Dividend Distribution policy as per Regulation 43A(1)",
        url: pdf_dividend,
    },
    {
        num: "26.1",
        description: "Annual return as provided under section 92 of the Companies Act, 2013",
        internalRoute: "/financial",
    },
    {
        num: "26.2",
        description: "Employee Benefit scheme documents framed in terms of SEBI (SBEB) Regulations, 2021",
        url: pdf_esop,
    },
];

// ── Row Action component ─────────────────────────────────────────────────────
const RowAction = ({ item }) => {
    const navigate = useNavigate();

    if (item.notApplicable) {
        return <span className="dur-na-badge">Not applicable</span>;
    }

    if (item.internalRoute) {
        const hasHash = item.internalRoute.includes("#");

        const handleClick = (e) => {
            if (hasHash) {
                e.preventDefault();
                const [path, hash] = item.internalRoute.split("#");
                navigate(path);
                // Scroll after navigation renders
                setTimeout(() => {
                    const el = document.getElementById(hash);
                    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                }, 300);
            }
        };

        return hasHash ? (
            <a
                href={item.internalRoute}
                className="dur-click-link"
                onClick={handleClick}
            >
                Click Here <ArrowIcon />
            </a>
        ) : (
            <Link to={item.internalRoute} className="dur-click-link">
                Click Here <ArrowIcon />
            </Link>
        );
    }

    // External PDF or "#"
    const isPlaceholder = !item.url || item.url === "#";
    return (
        <a
            href={isPlaceholder ? "#" : item.url}
            target={isPlaceholder ? "_self" : "_blank"}
            rel="noopener noreferrer"
            className={`dur-click-link${isPlaceholder ? " dur-click-link--disabled" : ""}`}
            onClick={isPlaceholder ? (e) => e.preventDefault() : undefined}
        >
            Click Here <ArrowIcon />
        </a>
    );
};

// ── Main Component ───────────────────────────────────────────────────────────
const DiclosureUnderRegulation = () => {
    return (
        <div className="dur-page">
            {/* ── HERO ── */}
            <section className="dur-hero">
                <div className="dur-hero-content">
                    <h1>Disclosure under Regulation 46</h1>
                    <img src={section2img} alt="Decorative" className="home-section2-image" />
                    <p>
                        Statutory disclosures mandated under Regulation 46 of SEBI (Listing Obligations and
                        Disclosure Requirements) Regulations, 2015.
                    </p>
                </div>
            </section>

            {/* ── BREADCRUMB ── */}
            <div className="dur-breadcrumb-container">
                <div className="dur-breadcrumb-wrapper">
                    <Link to="/" className="dur-breadcrumb-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
                            <path d="M10 14V8.66667C10 8.48986 9.92976 8.32029 9.80474 8.19526C9.67971 8.07024 9.51014 8 9.33333 8H6.66667C6.48986 8 6.32029 8.07024 6.19526 8.19526C6.07024 8.32029 6 8.48986 6 8.66667V14" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2 6.66667C1.99995 6.47271 2.04222 6.28108 2.12386 6.10514C2.20549 5.92921 2.32453 5.7732 2.47267 5.648L7.13933 1.64867C7.37999 1.44527 7.6849 1.33368 8 1.33368C8.3151 1.33368 8.62001 1.44527 8.86067 1.64867L13.5273 5.648C13.6755 5.7732 13.7945 5.92921 13.8761 6.10514C13.9578 6.28108 14 6.47271 14 6.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V6.66667Z" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Home
                    </Link>
                    <span className="dur-breadcrumb-separator">›</span>
                    <Link to="/investor-relation" className="dur-breadcrumb-link">
                        Investors
                    </Link>
                    <span className="dur-breadcrumb-separator">›</span>
                    <span className="dur-breadcrumb-current">Disclosure under Regulation 46</span>
                </div>
            </div>

            {/* ── CONTENT ── */}
            <div className="dur-content">
                <div className="dur-content-inner">
                    {/* Section Header */}
                    <div className="dur-section-header">
                        <div>
                            <h2 className="dur-section-title">Disclosure under Regulation 46</h2>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="dur-table-wrapper">
                        <table className="dur-table">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Description</th>
                                    <th>Link</th>
                                </tr>
                            </thead>
                            <tbody>
                                {DISCLOSURE_DATA.map((item, idx) => (
                                    <tr key={idx}>
                                        <td className="dur-td-num">{item.num}</td>
                                        <td className="dur-td-desc">{item.description}</td>
                                        <td className="dur-td-action">
                                            <RowAction item={item} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiclosureUnderRegulation;